export default "__VITE_ASSET__BaI7yC4x__"